<div class="app-shell">
  <div class="app-bg" [style.transform]="'translateY(' + bgOffset() + 'px)'"></div>

  <div class="app-banner">
    <fw-app-header />
    <router-outlet />
  </div>
</div>
